import { render, staticRenderFns } from "./VVdpArticleForm.vue?vue&type=template&id=276ac76b"
import script from "./VVdpArticleForm.vue?vue&type=script&lang=js"
export * from "./VVdpArticleForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports